import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { HelmetProvider } from 'react-helmet-async';
// Set page title
document.title = 'Fifth Door';
render(<HelmetProvider data-id="element-83">
    <App data-id="element-84" />
  </HelmetProvider>, document.getElementById('root'));